<p-dialog [(visible)]="visible" [modal]="true" [style]="{ width: '60vw' }"
  [breakpoints]="{ '960px': '80vw', '640px': '95vw' }" [draggable]="false" (onHide)="closeDialog()" [resizable]="false">
  <ng-template pTemplate="header">
    <div class="d-flex align-items-center gap-3 w-full">
      <div class="avatar-carousel-wrapper d-flex align-items-center gap-2">
        @if ((user()?.profilePhotos || []).length > 1) {
          <button type="button" class="btn-icon-carousel" (click)="prevPhoto($event)" aria-label="Previous photo">
            <i class="pi pi-chevron-left"></i>
          </button>
        }

        <div class="position-relative d-inline-block">
          <p-avatar
            [image]="getProfileImage()"
            [label]="getProfileImage() ? undefined : getInitials()"
            size="xlarge"
            [style]="{
              'background-color': getProfileImage() ? 'transparent' : getAvatarColor(),
              color: '#ffffff',
              'font-size': '1.5rem',
              'cursor': getProfileImage() ? 'pointer' : 'default'
            }"
            styleClass="user-avatar"
            (click)="getProfileImage() && openImageInNewTab($event)"
            (onImageError)="onAvatarError($event)">
          </p-avatar>

        </div>

        @if ((user()?.profilePhotos || []).length > 1) {
          <button type="button" class="btn-icon-carousel" (click)="nextPhoto($event)" aria-label="Next photo">
            <i class="pi pi-chevron-right"></i>
          </button>
        }
      </div>
      <div class="flex-1">
        <div class="d-flex align-items-center gap-2 mb-1">
          <h3 class="m-0 text-white font-bold">{{ fullName() | titlecase}}</h3>
          @if (user()?.voiceRecordUrl || user()?.voiceBio) {
          <button class="voice-btn tooltip-wrap"
            [class.playing]="isPlaying()"
            (click)="playVoiceRecord(user()?.voiceRecordUrl || user()?.voiceBio)"
            aria-label="Play bio">
            <i class="pi" [class]="isPlaying() ? 'pi-volume-up' : 'pi-volume-down'"></i>
            <span class="tooltip-box">Play voice bio</span>
          </button>
          }
          @if (user()?.isPartner) {
            <p-tag icon="pi pi-star" value="Partner" styleClass="p-tag-warning" styleClass="partner-badge" />
          }
        </div>
        <div class="flex align-items-center gap-2">
          <small class="text-white opacity-90">
            <i class="pi pi-envelope mr-1"></i>
            {{ user()?.email }}
          </small>
          @if (user()?.emailVerified) {
            <span class="tooltip-wrap">
              <i class="pi pi-verified text-green-300"></i>
              <span class="tooltip-box">Email Verified</span>
            </span>
          }
        </div>
      </div>
    </div>
  </ng-template>

  @if (user(); as userData) {
    <div class="user-details">
      <!-- Status Overview -->
      <div class="section">
        <h4 class="section-title">
          <i class="pi pi-chart-line mr-2"></i>
          Status Overview
        </h4>
        <div class="status-grid">
          <div class="status-card" [class.active]="userData.isActive">
            <i class="pi pi-user status-icon"></i>
            <div class="status-content w-100">
              <div class="d-flex justify-content-between align-items-center mb-1">
                <span class="status-label">Account Status</span>
              </div>
              <p-tag [value]="userData.accountStatus ? (userData.accountStatus | titlecase) : (userData.isActive ? 'Active' : 'Inactive')"
                [styleClass]="userData.accountStatus === 'banned' || (!userData.accountStatus && !userData.isActive) ? 'bg-danger' : (userData.accountStatus === 'suspended' ? 'bg-warning' : 'bg-success')" />
              </div>
            </div>

            <div class="status-card" [class.active]="userData.isSubscriptionActive">
              <i class="pi pi-ticket status-icon"></i>
              <div class="status-content">
                <span class="status-label">Subscription</span>
                <p-tag [value]="userData.subscriptionType"
                  [styleClass]="getSubscriptionSeverity(userData.subscriptionType)" />
                </div>
              </div>

              <div class="status-card" [class.active]="userData.registrationCompleted">
                <i class="pi pi-check-circle status-icon"></i>
                <div class="status-content">
                  <span class="status-label">Registration</span>
            <p-tag [value]="
                  userData.registrationCompleted ? 'Completed' : 'Incomplete'
                " [styleClass]="userData.registrationCompleted ? 'bg-success' : 'bg-warning'
                " />
                  </div>
                </div>

                <div class="status-card" [class.active]="userData.isPartner">
                  <i class="pi pi-briefcase status-icon"></i>
                  <div class="status-content">
                    <span class="status-label">Partner Status</span>
                    <p-tag [value]="userData.isPartner ? 'Partner' : 'User'"
                      [styleClass]="userData.isPartner ? 'bg-info' : 'bg-warning'" />
                    </div>
                  </div>
                </div>
              </div>

              <p-divider></p-divider>

              <!-- Personal Information -->
              <div class="section">
                <h4 class="section-title">
                  <i class="pi pi-user mr-2"></i>
                  Personal Information
                </h4>
                <div class="grid">
                  <div class="col-12 md:col-6 item-row">
                    <label class="detail-label">Full Name</label>
                    <p class="detail-value">
                      {{ userData.firstName || userData.lastName ? `${userData.firstName} ${userData.lastName}` : 'N/A' }}
                    </p>
                  </div>
                  <div class="col-12 md:col-6 item-row">
                    <label class="detail-label">User ID</label>
                    <p class="detail-value">
                      <code class="user-id">{{ userData._id ? userData._id : 'N/A'}}</code>
                    </p>
                  </div>
                  <div class="col-12 md:col-6 item-row">
                    <label class="detail-label">Phone Number</label>
                    <div class="flex align-items-center gap-2">
                      <span class="detail-value">{{ userData.phoneNumber ? userData.phoneNumber : 'N/A' }}&nbsp;</span>
                      @if (userData.phoneVerified) {
                        <span class="tooltip-wrap">
                          <i class="pi pi-verified text-green-500"></i>
                          <span class="tooltip-box">Phone Verified</span>
                        </span>
                      }
                    </div>
                  </div>
                  @if (userData.phoneNumberCarrierName) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label">Phone Carrier</label>
                      <p class="detail-value">{{ userData.phoneNumberCarrierName }}</p>
                    </div>
                  }
                  @if (userData.phoneNumberType) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label">Phone Type</label>
                      <p class="detail-value">{{ userData.phoneNumberType | titlecase }}</p>
                    </div>
                  }
                  @if (userData.age) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label">Age</label>
                      <p class="detail-value">{{ userData.age ? userData.age : 'N/A' }} years</p>
                    </div>
                  }
                  @if (userData.gender) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label">Gender</label>
                      <div class="d-flex align-items-center gap-2 detail-value">
                        <span>{{ userData.gender }}</span>
                        <i [class]="getGenderIcon(userData.gender)"></i>
                      </div>
                    </div>
                  }
                  @if (userData.updatedAt) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label">Last Active</label>
                      <p class="detail-value">
                        <i class="pi pi-clock mr-2 text-500"></i>
                        {{ userData.updatedAt | date: "mediumDate" }}
                      </p>
                    </div>
                  }
                  @if (userData.location) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label">Location</label>
                      <p class="detail-value">{{ userData.location ? this.location() : 'N/A' }}</p>
                    </div>
                  }
                  @if (userData.createdAt) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label">Member Since</label>
                      <p class="detail-value">
                        <i class="pi pi-calendar mr-2 text-500"></i>
                        {{ userData.createdAt ? (userData.createdAt | date: "mediumDate") : 'N/A' }}
                      </p>
                    </div>
                  }
                  @if (true) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label">xApplication Type</label>
                      <p class="detail-value">{{ userData.xApplicationType ? userData.xApplicationType : 'N/A' }}</p>
                    </div>
                  }
                  <div class="col-12 md:col-6 item-row">
                    <label class="detail-label">Auth Provider</label>
                    <div class="d-flex align-items-center gap-2 detail-value">
                      @if (userData.auth_provider) {
                        <i [class]="getAuthProviderIcon(userData.auth_provider)"></i>
                        <span>{{ userData.auth_provider | titlecase }}</span>
                      } @else {
                        <span>N/A</span>
                      }
                    </div>
                  </div>
                  @if (userData.deletedAt) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label text-danger">Deleted At</label>
                      <p class="detail-value text-danger">
                        <i class="pi pi-trash mr-2"></i>
                        {{ userData.deletedAt | date: "mediumDate" }}
                      </p>
                    </div>
                  }
                  @if (userData.reason && userData.accountStatus !== 'active') {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label text-danger">{{ userData.accountStatus | titlecase }} Reason</label>
                      <p class="detail-value text-danger">{{ userData.reason }}</p>
                    </div>
                  }
                  @if (userData.suspendedUntil) {
                    <div class="col-12 md:col-6 item-row">
                      <label class="detail-label text-warning">Suspended Until</label>
                      <p class="detail-value text-warning">{{ userData.suspendedUntil | date:'medium' }}</p>
                    </div>
                  }
                  @if (userData.accountStatus === 'suspended' && userData.suspendedServices?.length) {
                    <div class="col-12 md:col-6 item-row" style="align-items: center;">
                      <label class="detail-label text-warning mb-0">Restricted Services</label>
                      <div class="flex flex-wrap gap-1">
                        @for (srv of userData.suspendedServices; track srv) {
                          <p-tag [value]="srv | titlecase" severity="secondary"></p-tag>
                        }
                      </div>
                    </div>
                  }
                </div>
              </div>

              <p-divider></p-divider>

              <!-- Verification Status -->
              <div class="section">
                <h4 class="section-title">
                  <i class="pi pi-shield mr-2"></i>
                  Verification Status
                </h4>
                <div class="verification-grid">
                  <div class="verification-item">
                    <div class="verification-icon" [class.verified]="userData.emailVerified">
            <i [class]="
                  userData.emailVerified ? 'pi pi-check' : 'pi pi-times'
                "></i>
                    </div>
                    <div class="verification-content">
                      <span class="verification-label">Email Verification</span>
                      <span class="verification-status" [class.verified]="userData.emailVerified">
                        {{ userData.emailVerified ? "Verified" : "Not Verified" }}
                      </span>
                    </div>
                  </div>

                  <div class="verification-item">
                    <div class="verification-icon" [class.verified]="userData.phoneVerified">
            <i [class]="
                  userData.phoneVerified ? 'pi pi-check' : 'pi pi-times'
                "></i>
                    </div>
                    <div class="verification-content">
                      <span class="verification-label">Phone Verification</span>
                      <span class="verification-status" [class.verified]="userData.phoneVerified">
                        {{ userData.phoneVerified ? "Verified" : "Not Verified" }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <p-divider></p-divider>

              <!-- Activity Statistics -->
              <div class="section">
                <h4 class="section-title">
                  <i class="pi pi-chart-bar mr-2"></i>
                  Activity Statistics
                </h4>
                <div class="stats-grid">
                  <div class="stat-card">
                    <div class="stat-icon lobbies">
                      <i class="pi pi-users"></i>
                    </div>
                    <div class="stat-content">
                      <span class="stat-value">{{
                        userData.totalLobbiesJoined || 0
                      }}</span>
                      <span class="stat-label">Lobbies Joined</span>
                    </div>
                  </div>

                  <div class="stat-card">
                    <div class="stat-icon matches">
                      <i class="pi pi-trophy"></i>
                    </div>
                    <div class="stat-content">
                      <span class="stat-value">{{ userData.totalMatches || 0 }}</span>
                      <span class="stat-label">Total Matches</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </p-dialog>

        @if (isStatusModalVisible() && user()) {
          <app-user-status-modal
            [visible]="isStatusModalVisible()"
            (onClose)="closeStatusModal()"
            [user]="user()!"
            (onAction)="handleStatusAction($event)">
          </app-user-status-modal>
        }